
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicles/[enquiryId]",
      function () {
        return require("private-next-pages/vehicles/[enquiryId].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicles/[enquiryId]"])
      });
    }
  